const Sign = ({ style }) => {
  return (
    <svg
      className={style}
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <g clipPath='url(#clip0_4416_14402)'>
        <path
          d='M19.8902 9.65C19.5302 9.23 19.5702 8.6 19.9902 8.24C20.4102 7.88 21.0402 7.92 21.4002 8.34C22.4702 9.58 23.2502 11.05 23.7202 12.72C23.8702 13.25 23.5602 13.8 23.0302 13.95C22.9402 13.98 22.8502 13.99 22.7602 13.99C22.3202 13.99 21.9202 13.7 21.8002 13.26C21.4102 11.87 20.7602 10.66 19.8902 9.64V9.65ZM23.9502 17.31C22.5902 21.39 19.6402 21.99 18.0002 21.99C16.5902 21.99 15.3602 21.37 14.3402 20.44C13.1602 21.37 11.7102 21.99 10.0002 21.99C8.29022 21.99 6.78022 21.04 5.37022 19.59C4.12022 20.79 2.04022 21.99 1.00022 21.99C0.540216 21.99 0.120216 21.66 0.0202159 21.19C-0.0897841 20.65 0.260216 20.12 0.800216 20.01C1.95022 19.77 3.06022 19.05 4.07022 18.05C1.64022 14.78 0.000215918 10.24 0.000215918 7.5C0.000215918 4.57 2.54022 2 5.43022 2C8.32022 2 11.0002 4.62 11.0002 7.5C11.0002 10.19 9.35022 14.79 6.71022 18.11C7.79022 19.26 8.93022 20 10.0002 20C11.1702 20 12.1902 19.58 13.0202 18.94C11.7102 17.08 11.0002 14.82 11.0002 13.46C11.0002 11.62 12.6402 10.01 14.5102 10.01C16.3802 10.01 18.0002 11.62 18.0002 13.46C18.0002 14.97 17.2302 17.23 15.7702 19.04C16.4402 19.63 17.1902 20.01 18.0002 20.01C19.9502 20.01 21.3202 18.89 22.0502 16.69C22.2202 16.17 22.7902 15.88 23.3202 16.06C23.8402 16.23 24.1302 16.8 23.9502 17.33V17.31ZM9.00022 7.5C9.00022 5.7 7.26022 4 5.43022 4C3.60022 4 2.00022 5.67 2.00022 7.5C2.00022 9.89 3.47022 13.7 5.41022 16.49C7.55022 13.61 9.00022 9.7 9.00022 7.5ZM14.4502 17.46C15.4702 16.06 16.0002 14.41 16.0002 13.46C16.0002 12.73 15.2602 12.01 14.5102 12.01C13.7602 12.01 13.0002 12.74 13.0002 13.46C13.0002 14.41 13.5502 16.06 14.4502 17.46Z'
          fill='#006FAD'
        />
      </g>
      <defs>
        <clipPath id='clip0_4416_14402'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Sign